<div class="avatar-container">
  <div class="outer" [class.filled]="filled" [style.background-image]="'url(' + (src$ | async) + ')'"></div>
</div>
